import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export interface OrganisationCodeSelectorProps {
  codes: string[];
  selectedCode?: string;
  onCodeChange?: (code: string) => void;
  dataTestId?: string;
}

export default function OrganisationCodeSelector({
  codes,
  selectedCode = '',
  onCodeChange,
  dataTestId,
}: Readonly<OrganisationCodeSelectorProps>) {
  if (codes.length === 0) {
    return null;
  }

  return (
    <FormControl
      fullWidth
      sx={(theme) => ({ marginBottom: theme.semantic.spacing.base })}
      data-testid={dataTestId}
    >
      <InputLabel id="organisation-code-select-label">Organisation Code</InputLabel>
      <Select
        labelId="organisation-code-select-label"
        id="organisation-code-select"
        value={selectedCode}
        label="Organisation Code"
        onChange={(e) => onCodeChange?.(e.target.value)}
      >
        {codes.map((code) => (
          <MenuItem key={code} value={code}>
            {code}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
